module.exports = __webpack_public_path__ + "img/index02.95abf037.svg";